import { defineComponent, h } from 'vue';
import { Icon } from '@/ui/components/icon/Icon';
import { box } from '@/ui/components';
import { EventBus } from '@/ui/EventBus';
import { Events } from '@/ui/events';
import { t } from '@/ui/i18n/i18n';

export const InformationBoxSeeDetails = defineComponent({
  name: 'InformationBoxSeeDetails',
  setup() {
    const onClickHere = () => {
      EventBus.$emit(Events.seeMoreDetailsIssue, true);
    };

    return function render() {
      return h('div', [
        box([
          h(Icon, {
            props: {
              icon: 'file-exclamation',
              iconPack: 'far',
            },
          }),
          h('span', { class: 'd-inline-block ml-2' }, [
            t('issues.item-related-to-issue'),
          ]),
          h('span', { class: 'issue-with-logs__report-title', on: { click: onClickHere } }, [
            t('issues.details'),
          ]),
        ], { class: 'issue-with-logs__information-box' }),
      ]);
    };
  },
});

export function informationBoxSeeDetails() {
  return h(InformationBoxSeeDetails);
}
